import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { Observable, throwError, from, BehaviorSubject } from 'rxjs';
import { TokenStorageService } from './token-storage-service';
import { ConfigService } from '../services/config.service';
import { CurrentUserService } from '../services/current-user.service';

const apiRoute = 'hubconnectusermanagementapi';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor(
    private tokenStorage: TokenStorageService,
    private configService: ConfigService,
    private userService: CurrentUserService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const errorCB: any = this.errorHandlerFactory(request, next);
    return from(this.interceptHelper(request, next));
  }

  async interceptHelper(request: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    const newRequest = await this.addAuthenticationToken(request);
    return next.handle(newRequest).toPromise();
  }

  private errorHandlerFactory(request, next) {
    return function (error: any) {
      if (error && error.status === 401) {
        console.log('token expired?', this.tokenStorage.tokenExpired());
        if (!this.tokenStorage.tokenExpired()) {
          // this.router.navigateByUrl(this.routes.InvalidAccess);
          return throwError(error);
        } else if (this.tokenStorage.tokenExpired()) {
          console.log('refresh from 401');
          return this.handleRefreshLogic('refresh', request, next);
        } else {
          return throwError(error);
        }
      } else if (error && error.status === 400) {
        if (
          !this.tokenStorage.getAccessToken() &&
          !this.tokenStorage.getRefreshToken()
        ) {
          console.log('relogin from 400');
          return this.handleRefreshLogic('relogin', request, next);
        } else if (
          !this.tokenStorage.getAccessToken() &&
          this.tokenStorage.getRefreshToken()
        ) {
          console.log('refresh from 400');
          return this.handleRefreshLogic('refresh', request, next);
        } else {
          return throwError(error);
        }
      } else {
        return throwError(error);
      }
    };
  }

  private async addAuthenticationToken(request: HttpRequest<any>): Promise<HttpRequest<any>> {
    if ((request.url.includes('oauth/token') && request.method !== 'DELETE')) {
      return Promise.resolve(request);
    } else {
      if ((request.url.includes('customer_requests') && request.method === 'POST')) {
        return request;
      }
      let token;
      // take impersonator token if user is logged in as impersonator
      // for /support and users dropdown for impersonating
      if (request.url && (request.url.includes('/support') || request.url.includes('/user/dropdown/SUPPLIER') || request.url.includes('/user/dropdown/CUSTOMER'))) {
        const isImpersonator = await this.tokenStorage.isImpersonator();
        if (isImpersonator) {
          const impersonator = await this.tokenStorage.getImpersonator();
          token = JSON.parse(impersonator).token;
        }
      }

      if(!token) {
        token = await this.tokenStorage.getAccessToken(false);
      }

      const envConfig = await this.configService.getConfig();
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          'X-Api-Version': envConfig
            ? envConfig.apiVersion
            : '1.0'
        }
      });
    }
  }

  private RefreshAccessToken(): Observable<any> {
    return from(
      this.userService.refreshToken()
        .catch(error => {
          console.log('Error from refreshing user svc in refresh interceptor');
        })
    );
  }
}
